// extracted by mini-css-extract-plugin
var _1 = "HomeworkTabContent__currentHW--W26PM";
var _2 = "HomeworkTabContent__header--wthWb fontSize__profileText--q79uE";
var _3 = "HomeworkTabContent__headerText--cP0Je";
var _4 = "HomeworkTabContent__legend--iOxbu";
var _5 = "HomeworkTabContent__rowsContainer--GLRYU";
var _6 = "HomeworkTabContent__scrollBar--qqZCd general__scrollBar--nOeLI";
var _7 = "HomeworkTabContent__scrollThumb--NgUdh general__scrollThumb--k3VcQ";
var _8 = "HomeworkTabContent__weeksInnerContainer--HElju";
var _9 = "HomeworkTabContent__weeksOuterContainer--h1w9E";
export { _1 as "currentHW", _2 as "header", _3 as "headerText", _4 as "legend", _5 as "rowsContainer", _6 as "scrollBar", _7 as "scrollThumb", _8 as "weeksInnerContainer", _9 as "weeksOuterContainer" }
